'use client';

import { useState, useCallback } from 'react';
import { AUTH_ENDPOINTS } from '@impact/auth';
import { useTenant } from '@/hooks/use-tenant';
export function useLogout() {
  const tenantId = useTenant();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = useCallback(async () => {
    setIsLoggingOut(true);

    try {
      const endpoint = tenantId ? AUTH_ENDPOINTS.tenant.signOut : AUTH_ENDPOINTS.platform.signOut;

      await fetch(endpoint, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...(tenantId && { 'X-Tenant-ID': tenantId }),
        },
        body: JSON.stringify({}),
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      window.location.href = '/';
    }
  }, [tenantId]);

  return { logout, isLoggingOut };
}
